var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlarm = function SvgAlarm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M9 3.583a4.167 4.167 0 0 1 4.167 4.167v1.74a2 2 0 0 0 .505 1.328l.609.686c.86.967.173 2.496-1.121 2.496H4.84c-1.294 0-1.98-1.53-1.12-2.496l.608-.686a2 2 0 0 0 .505-1.328V7.75A4.167 4.167 0 0 1 9 3.583m0 0V1.5m-.833 15h1.666"
  })));
};
export default SvgAlarm;